module.exports = __webpack_public_path__ + "static/media/Questionaire.687e5f68.png";